// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__kl7fs","welcomeText":"LandingPage_welcomeText__bjYiZ","heading":"LandingPage_heading__EwLJc"};